const WINDOW_WIDTH = 550;
const WINDOW_HEIGHT = 700;

export type TShareTarget = "facebook" | "twitter" | "linkedin";

export const shareTargets: TShareTarget[] = ["facebook", "twitter", "linkedin"];

export const buildShareUrl = (target: TShareTarget, url: string) => {
  const encoded = encodeURIComponent(url);

  switch (target) {
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${encoded}`;
    case "twitter":
      return `http://www.twitter.com/share?url=${encoded}`;
    case "linkedin":
      return `https://www.linkedin.com/shareArticle?url=${encoded}`;
  }
};

export const getShareTargetName = (target: TShareTarget) => {
  switch (target) {
    case "facebook":
      return "Facebook";
    case "twitter":
      return "X";
    case "linkedin":
      return "LinkedIn";
  }
};

export const openShareWindow = (target: TShareTarget, url: string) => {
  const shareUrl = buildShareUrl(target, url);

  const featuresObject = {
    height: WINDOW_HEIGHT,
    width: WINDOW_WIDTH,
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - WINDOW_WIDTH / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - WINDOW_HEIGHT / 2,
  };

  const features = Object.entries(featuresObject)
    .map(entry => `${entry[0]}=${entry[1]}`)
    .join(",");

  window.open(shareUrl, target, features);
};
